import {PRConnect} from "@projectroom/ui-lib";
import { accessToken } from "./../views/store/auth-store";
import { get } from 'svelte/store';

const axiosInst = PRConnect.instance();

axiosInst.interceptors.request.use((config) => {
  const token = get(accessToken);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});